<template>
  <svg
  class="icon-line"
    width="15"
    height="4"
    viewBox="0 0 24 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 2H23.5" stroke="CurrentColor" stroke-width="3" />
  </svg>
</template>
<style>

@media (min-width: 768px) {
  .icon-line {
    width: 20px;
  }
}
@media (min-width: 1024px) {
  .icon-line {
    width: 25px;
  }
}
</style>
